import { Injectable } from '@angular/core';
import { ContentApiService } from '@alfresco/aca-shared';
import { UserPreferencesService } from '@alfresco/adf-core';
import { Node, NodeEntry } from '@alfresco/js-api';
import { AlfrescoApiService } from '@alfresco/adf-content-services';
import { Observable, from } from 'rxjs';

import { WkAlfrescoApiService } from './wk-alfresco-api.service';
import { WkAppConfigService } from './wk-app-config.service';

@Injectable({
  providedIn: 'root',
})
export class WkContentApiService extends ContentApiService {
  constructor(
    preferences: UserPreferencesService,
    api: AlfrescoApiService,
    private readonly wkApi: WkAlfrescoApiService,
    private readonly appConfig: WkAppConfigService
  ) {
    super(api, preferences);
  }

  getNodeInfo(nodeId: string, options?: any): Observable<Node> {
    const defaults = {
      include: ['isFavorite', 'allowableOperations', 'path'],
    };
    const queryOptions = Object.assign(defaults, options || {});

    const nodeInfoPromise = this.wkApi.nodesApi
      .getNode(nodeId, queryOptions)
      .then((nodeEntry: NodeEntry) => {
        if (!this.appConfig.get('externalMetadataApi.isActive')) {
          return nodeEntry.entry;
        }

        return this.getExternalMetadata(nodeEntry.entry, queryOptions);
      });

    return from(nodeInfoPromise);
  }

  getExternalMetadata(node: Node, queryOptions?: any): Promise<any> {
    node.properties['cm:name'] = node.name;
    if (node.createdAt) {
      node.properties['cm:created'] = node.createdAt;
      node.properties['cm:creator'] = node.createdByUser.displayName;
      node.properties['cm:modified'] = node.modifiedAt;
      node.properties['cm:modifier'] = node.modifiedByUser.displayName;
    }

    const contentTypes = ['application/json'];

    return this.wkApi
      .callContentClientCustomApi({
        path: `/nodes/${node.id}/externals/externals`,
        httpMethod: 'GET',
        queryParams: queryOptions,
        contentTypes,
        accepts: contentTypes,
      })
      .then((extNode: NodeEntry) => {
        node.aspectNames = [...node.aspectNames, ...extNode.entry.aspectNames];
        node.properties = Object.assign(
          node.properties,
          extNode.entry.properties
        );

        return node;
      });
  }
}
